import { render, staticRenderFns } from "./StockSetDialog.vue?vue&type=template&id=0b0a819b&scoped=true&"
import script from "./StockSetDialog.vue?vue&type=script&lang=js&"
export * from "./StockSetDialog.vue?vue&type=script&lang=js&"
import style0 from "./StockSetDialog.vue?vue&type=style&index=0&id=0b0a819b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a819b",
  null
  
)

export default component.exports